module.exports = __webpack_public_path__ + "img/img_31.9ca5b906.png";